import Script from 'next/script'
import React from 'react'
import { useDataProvider } from '../../hooks/dataProvider'

function AdScriptUrl({ url, directUrl = false, id, ...others }) {
    const { data } = useDataProvider()
    
    if (!data?.buildTime) return null

    return (
        <>
            {url &&
                Array.isArray(url) &&
                url.map(
                    (url, idx) => (
                        <Script
                            key={idx}
                            id={`${id}-${idx}`}
                            src={!directUrl ? `${url}${data?.buildTime?.replace(/[-.T:Z]/g, '')}` : url}
                            {...others}
                            async
                        ></Script>
                    )
                )}
            {url &&
                !Array.isArray(url) && (
                    <Script
                        id={id}
                        src={!directUrl ? `${url}${data?.buildTime?.replace(/[-.T:Z]/g, '')}` : url}
                        {...others}
                        async
                    ></Script>
                )

            }
        </>
    )
}

export default AdScriptUrl